import { CssBaseline } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import React from "react";
import getDesignTokens from "./theme";
import useColorMode from "../hooks/useColorMode";

const MuiTheme: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { colorMode } = useColorMode();
  const baseTheme = React.useMemo(
    () => createTheme(getDesignTokens(colorMode)),
    [colorMode]
  );
  const theme = { ...baseTheme };
  theme.shadows[1] = "0px 4px 20px 0px rgba(0,0,0,0.05)";
  theme.shadows[2] = "0px 4px 20px 0px rgba(0,0,0,0.1)";
  theme.shadows[3] = "0px 8px 45px rgba(3, 0, 71, 0.09)";
  theme.shadows[4] = "0px 0px 28px rgba(3, 0, 71, 0.01)";
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default MuiTheme;
